import { useAppSelector } from 'appState/store'
import moment from 'moment'
import styled from 'styled-components'

import { BatchType } from '../types'
import { Pie } from './CircularProgressbar'
import DeliveryText from './DeliveryWindow'
import { isOldBatchRecord } from './helper'

export const formatEOBReceived = (params: any) => {
  return (
    <Div>
      {params.data.batchType === BatchType.Claim_Autocheck_EOB ? <>{params.data.eobReceivedCount}</> : <div>N/A</div>}
    </Div>
  )
}

export const formatActionCheckProgress = (params: any) => {
  const now = 100 * (parseInt(params.data.statusAcquired) / parseInt(params.data.autocheckCount))
  return (
    <>
      {!isOldBatchRecord(params.data) ? (
        <Div>
          {params.data.batchType === BatchType.Claim_Import ? (
            'N/A'
          ) : (
            <>
              <Pie dataValue={now} /> {params.data.statusAcquired} Claim Statuses
            </>
          )}
        </Div>
      ) : (
        <>{parseInt(params.data.autoChecked)}</>
      )}
    </>
  )
}

export const formatDeliveryWindow = (params: any) => {
  const { eobDeliveryWindow } = useAppSelector((state) => state.auth)
  const timestamp = moment.utc(params.data.lastUpdatedTime)
  const current_time = moment.utc()
  const time_difference = moment.duration(current_time.diff(timestamp)).asMilliseconds()
  const time_left =
    (Number(eobDeliveryWindow) * 60 * 60 * 1000 - time_difference) % (Number(eobDeliveryWindow) * 60 * 60 * 1000)
  return (
    <Div>
      <DeliveryText timeLeft={time_left} />
    </Div>
  )
}

export const eobReceivedTime = (params: any) => {
  const { eobDeliveryWindow } = useAppSelector((state) => state.auth)
  const timestamp = moment.utc(params.data.lastUpdatedTime)
  const current_time = moment.utc()
  const time_difference = moment.duration(current_time.diff(timestamp)).asMilliseconds()
  const time_left =
    (Number(eobDeliveryWindow) * 60 * 60 * 1000 - time_difference) % (Number(eobDeliveryWindow) * 60 * 60 * 1000)

  const hours = Math.floor(time_left / (60 * 60 * 1000))
  const minutes = Math.round((time_left % (60 * 60 * 1000)) / (60 * 1000))

  return <>{hours + 'h ' + minutes + 'min'}</>
}

const Div = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
`
